import type { ConversationPartApiResponse } from "@f2e/ui/chat-v2"
import type { TFunction } from "i18next"

export const getPlatformReplyErrorMessage = (
  reply:
    | { status?: unknown; error_code?: unknown; error_message?: unknown }
    | undefined,
  t: TFunction
) => {
  if (reply?.error_code === "attachment_delivery_unknown")
    return t("history.replyAttachment.deliveryUnknown")
  if (reply?.error_code === "attachment_text_too_long")
    return t("history.replyAttachment.textTooLong")
  if (
    typeof reply?.error_code === "string" &&
    reply.error_code.startsWith("attachment_")
  )
    return t("history.replyAttachment.deliveryFailed")
  if (reply?.error_code === "line_monthly_limit_reached") {
    return t(
      reply.status === "sent"
        ? "history.platformReply.lineMonthlyLimitPartial"
        : "history.platformReply.lineMonthlyLimitReached"
    )
  }
  if (reply?.error_code === "line_rate_limited") {
    return t(
      reply.status === "sent"
        ? "history.platformReply.lineRateLimitedPartial"
        : "history.platformReply.lineRateLimited"
    )
  }
  if (
    (typeof reply?.error_code === "string" &&
      reply.error_code.startsWith("line_")) ||
    (typeof reply?.error_message === "string" &&
      /^line_[a-z_]+(?::\d+)?$/.test(reply.error_message.trim()))
  ) {
    return t(
      reply?.status === "sent"
        ? "history.platformReply.lineDeliveryPartial"
        : "history.platformReply.deliveryFailedFallback"
    )
  }
  return typeof reply?.error_message === "string" && reply.error_message.trim()
    ? reply.error_message
    : undefined
}

export const getPlatformReplyActorDisplayName = (
  part: ConversationPartApiResponse
) => {
  const platformReply = part.metadata.platform_reply
  if (!platformReply || typeof platformReply !== "object") return undefined
  const actorUser = platformReply.actor_user
  if (!actorUser || typeof actorUser !== "object") return undefined
  const displayName = actorUser.display_name
  return typeof displayName === "string" && displayName.trim()
    ? displayName
    : undefined
}

export const hasSentPlatformReply = (
  parts: ConversationPartApiResponse[],
  partId: number
) =>
  parts.some(
    (part) =>
      part.id === partId &&
      part.part_kind === "text" &&
      part.metadata.source === "platform_reply" &&
      part.metadata.platform_reply?.status === "sent"
  )

export const isPartialPlatformReply = (part: ConversationPartApiResponse) => {
  const platformReply = part.metadata.platform_reply
  if (!platformReply || typeof platformReply !== "object") return false
  return (
    platformReply.status === "sent" &&
    typeof platformReply.error_code === "string" &&
    Boolean(platformReply.error_code.trim())
  )
}
